import React, { useState, useEffect } from "react";
import Rating from "@material-ui/lab/Rating";
import { withStyles } from "@material-ui/core/styles";
import Star from "@material-ui/icons/Star";
import * as theme from "../theme";
import { useDispatch, useSelector } from "react-redux";
import { changeResponseStarrating, updateStarRating } from "../store/quotes";
// const timeout = (delay) => {
//   return new Promise((res) => setTimeout(res, delay));
// };

const calculateStarColor = (value) => {
  if (value) {
    if (value > 4 && value <= 5) {
      return theme.COLORS.dark_green_dot;
    } else if (value > 1 && value <= 4) {
      return theme.COLORS.golden_star;
    } else if (value >= 0 && value <= 1) return theme.COLORS.red_star;
    else return "red";
  } else {
    return "grey";
  }
};

const StarRating = (props) => {
  const {
    responseid,
    starrating,
    handleOnChange,
    showDiffrentColors,
    checkedforcompare,
  } = props;
  const readonly = props.readonly ? props.readonly : false;
  const [show, setShow] = useState(false);

  const StyledRating = withStyles({
    root: {
      fontSize: "2.3vmin",
    },
    icon: {
      color: checkedforcompare
        ? theme.COLORS.little_darker_lightindigo
        : "lightgrey",
    },
    iconFilled: {
      color: showDiffrentColors ? calculateStarColor(starrating) : "grey",
    },
    iconHover: {
      color: "grey",
    },
  })(Rating);

  useEffect(() => {
    const timeout = setTimeout(() => setShow(true), 300);
    return () => clearTimeout(timeout);
  });

  return (
    <div>
      {show ? (
        <div>
          <StyledRating
            precision={1}
            readOnly={readonly}
            name={responseid}
            icon={<Star fontSize="inherit" />}
            emptyIcon={<Star fontSize="inherit" />}
            value={starrating}
            onChange={handleOnChange}
          />
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
};

export const StarRatingForInsurerHub = (props) => {
  const { responseid, checkedforcompare } = props;

  const starrating = useSelector((state) => {
    let responsedetails = state.entities.quotes.responsedetails[responseid];

    if (responsedetails) {
      return responsedetails.starrating;
    } else return responsedetails;
  });

  const dispatch = useDispatch();

  const prospectid = useSelector((state) => {
    return { current: state.entities.quotes.prospectid };
  });

  const handleOnChange = (event, value) => {
    dispatch(changeResponseStarrating({ responseid, starrating: value }));
    dispatch(
      updateStarRating({
        responseid,
        previousvalue: starrating,
        prospectid: prospectid.current,
        starrating: value,
      })
    );
  };

  return (
    <StarRating
      responseid={responseid}
      starrating={starrating}
      handleOnChange={handleOnChange}
      checkedforcompare={checkedforcompare}
    ></StarRating>
  );
};

export default StarRating;
